import { auth as authAdmin } from "@/middlewares/admin";

export default {
  path: "event-cms",
  name: "EdicAdminFacilityEventCmsManage",
  component: () =>
    import(
      /* webpackChunkName: "edic-admin-facility-management-event-cms-layout-view" */ "@/views/EdicAdmin/Facilities/Manage/EventCms/Layout"
    ),
  redirect: { name: "EdicAdminFacilityEventCmsSearch" },
  children: [
    {
      path: "", // /admin/event-cms
      name: "EdicAdminFacilityEventCmsSearch",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-event-cms-search" */ "@/views/EdicAdmin/Facilities/Manage/EventCms/Search"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
    {
      path: "create", // /admin/event-cms//create
      name: "EdicAdminFacilityEventCmsCreate",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-content-cms-create" */ "@/views/EdicAdmin/Facilities/Manage/EventCms/Create"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
    {
      path: "edit/:id", // /admin/event-cms//edit/1
      name: "EdicAdminFacilityEventCmsEdit",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-content-cms-edit" */ "@/views/EdicAdmin/Facilities/Manage/EventCms/Edit"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
  ],
};
